import React from 'react';
import { Alert, Button, Space, Tag, Typography } from 'antd';
import { UserSwitchOutlined, LogoutOutlined, UnlockOutlined } from '@ant-design/icons';
import { useImpersonation } from '../hooks/useImpersonation';

const { Text } = Typography;

export const ImpersonationBanner: React.FC = () => {
    const { isImpersonating, impersonationData, returnToAdmin, isLoading } = useImpersonation();

    if (!isImpersonating || !impersonationData) {
        return null;
    }

    const { impersonation, target_user } = impersonationData;

    return (
        <Alert
            type="warning"
            showIcon
            icon={<UserSwitchOutlined />}
            style={{
                margin: '0',
                borderRadius: '0',
                borderLeft: 'none',
                borderRight: 'none',
                borderTop: 'none',
            }}
            message={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Space>
                        <Text strong>
                            Impersonating: {target_user.firstName} {target_user.lastName}
                        </Text>
                        <Text type="secondary">
                            ({target_user.email}) • {target_user.organisationName}
                        </Text>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            Started by {impersonation.originalUsername} • Reason: {impersonation.reason}
                        </Text>
                        {impersonation.previewPlan && (
                            <Tag icon={<UnlockOutlined />} color="gold" style={{ marginLeft: 4 }}>
                                Previewing: {impersonation.previewPlan === 'ENTERPRISE' ? 'Enterprise' : 'Professional'}
                            </Tag>
                        )}
                    </Space>
                    
                    <Space>
                        <Button
                            type="link" 
                            size="small"
                            icon={<LogoutOutlined />}
                            loading={isLoading}
                            onClick={returnToAdmin}
                            style={{ 
                                color: '#d46b08',
                                padding: '2px 8px',
                                height: 'auto',
                                fontSize: '12px'
                            }}
                        >
                            End Impersonation
                        </Button>
                    </Space>
                </div>
            }
        />
    );
};